import Chart from 'chart.js/auto';
import {AlgoBase} from "./AlgoBase";

const green = 'rgba(199, 243, 209, 0.75)';
const red = 'rgba(243,200,200,0.75)';
const gray = 'rgb(236 236 236 / 0.75)';
const greenTransparent = 'rgba(199, 243, 209, 0';
const redTransparent = 'rgba(243,200,200,0)';

let _datasetIndex = 0;

export class ShotoChartJS extends AlgoBase {

  constructor(target) {
    super('shoto', target, false);
    this.init();
  }

  async init() {

    this.algortihmData = await this.buildDataset("data/algorithms/Shoto.csv");

    const ctx = this.$widget.find("canvas");

    this.chart = new Chart(ctx, {
      type: 'line',
      data: {
        labels: this.algortihmData.labels,
        datasets: [{
          label: 'Zone Temp Setpoint', // [dynamic value in loadDataset()],
          data: this.algortihmData.mainDatasets[0],
          borderColor: '#6400FF',
        }, {
          label: 'Zone Temp', // [dynamic value in loadDataset()],
          data: this.algortihmData.allDatasets[1],
          borderColor: '#000000',
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          annotation: {
            annotations: {
              box1: {
                type: 'box',
                borderWidth: 0,
                xMin: 16,
                xMax: 26,
                // yMin: [dynamic value in loadDataset()],
                // yMax: [dynamic value in loadDataset()],
                backgroundColor: green,
                drawTime: 'beforeDraw',
                z: 0,
                label: {
                  display: true,
                  position: 'center',
                  drawTime: 'afterDraw',
                  z: 2,
                  rotation: -90,
                  content: "Grid clean", // [dynamic value in loadDataset()],
                  color: '#000000',
                  font: Chart.defaults.plugins.annotation.common.label.font,
                  beforeDraw: (context, rect) => this.drawLabelBackground(context, rect, (_datasetIndex < 3) ? green : gray)
                }
              },
              box2: {
                type: 'box',
                borderWidth: 0,
                xMin: 26,
                xMax: 33,
                // yMin: [dynamic value in loadDataset()],
                // yMax: [dynamic value in loadDataset()],
                backgroundColor: red,
                drawTime: 'beforeDraw',
                z: 0,
                label: {
                  display: true,
                  position: 'center',
                  drawTime: 'afterDraw',
                  z: 2,
                  rotation: -90,
                  content: "Grid dirty", // [dynamic value in loadDataset()],
                  color: '#000000',
                  font: Chart.defaults.plugins.annotation.common.label.font,
                  beforeDraw: (context, rect) => this.drawLabelBackground(context, rect, (_datasetIndex < 3) ? red : gray)
                },
              },
              line1: {
                type: 'line',
                xMin: 16,
                xMax: 16,
                borderWidth: 1,
                borderColor: '#EB2B31',
                borderDash: [4, 4],
                drawTime: 'beforeDraw',
                z: 1,
                label: {
                  display: true,
                  backgroundColor: "transparent",
                  position: 'start',
                  xAdjust: -10,
                  drawTime: 'beforeDraw',
                  z: 2,
                  rotation: -90,
                  content: "Initiate event", // [dynamic value in loadDataset()],
                  color: '#000000',
                  font: Chart.defaults.plugins.annotation.common.label.font
                },
                afterDraw: (context) => this.drawLineMarker(context)
              },
              line2: {
                type: 'line',
                xMin: 26,
                xMax: 26,
                borderWidth: 1,
                borderColor: '#EB2B31',
                borderDash: [4, 4],
                drawTime: 'beforeDraw',
                z: 1,
                // label: {
                //   display: true,
                //   backgroundColor: "transparent",
                //   position: 'start',
                //   xAdjust: -10,
                //   drawTime: 'beforeDraw',
                //   z: 2,
                //   rotation: -90,
                //   content: "Precool Period", // [dynamic value in loadDataset()],
                //   color: '#000000',
                //   font: Chart.defaults.plugins.annotation.common.label.font
                // },
                afterDraw: (context) => this.drawLineMarker(context)
              },
              line3: {
                type: 'line',
                xMin: 33,
                xMax: 33,
                borderWidth: 1,
                borderColor: '#EB2B31',
                borderDash: [4, 4],
                drawTime: 'beforeDraw',
                z: 1,
                // label: {
                //   display: true,
                //   backgroundColor: "transparent",
                //   position: 'start',
                //   xAdjust: -10,
                //   drawTime: 'beforeDraw',
                //   z: 2,
                //   rotation: -90,
                //   content: "Thermal Drift", // [dynamic value in loadDataset()],
                //   color: '#000000',
                //   font: Chart.defaults.plugins.annotation.common.label.font
                // },
                afterDraw: (context) => this.drawLineMarker(context)
              },
            }
          },
          title: {
            display: true,
            text: 'OAT', // [dynamic value in loadDataset()],
          }
        },
        elements: {
          line: {
            tension: 0.3,
            borderColor: '#330808',
          }
        },
        scales: {
          x: this.setupXAxis(),
          y: {
            // min: [dynamic value in loadDataset()],
            // max: [dynamic value in loadDataset()],
            ticks: {
              callback: (value, index, ticks) => {
                return this.temperatureLegend(value); // Append the unit
              }
            },
          }
        },
      },
    });

    this.loadDataset(0)

    this.initEvents();

    this.ready();
  }

  loadDataset(datasetIndex) {
    _datasetIndex = datasetIndex;

    // Update data for preferred unit
    this.algortihmData.mainDatasets[datasetIndex] = this.convertDatasetToPreferredUnit(this.algortihmData.allDatasets[0][datasetIndex])
    this.chart.data.datasets[1].data = this.convertDatasetToPreferredUnit(this.algortihmData.allDatasets[1][datasetIndex])

    // Update y limits for preferred unit
    if (this.preferredUnit === "celsius") {
      this.chart.options.scales.y.min = 18
      this.chart.options.scales.y.max = 26
    } else {
      this.chart.options.scales.y.min = 64
      this.chart.options.scales.y.max = 80
    }

    // Synchronize annotations height with y limits
    this.chart.options.plugins.annotation.annotations.box1.yMin = this.chart.options.scales.y.min
    this.chart.options.plugins.annotation.annotations.box1.yMax = this.chart.options.scales.y.max

    // Update dynamic strings from CMS
    const isHeating = datasetIndex % (this.algortihmData.mainDatasets.length / 2) === 2;
    const isBase = datasetIndex % (this.algortihmData.mainDatasets.length / 2) === 0
    this.chart.data.datasets[0].label = this.getLegendFromCMS(1, 1);
    this.chart.data.datasets[1].label = this.getLegendFromCMS(2, 1);
    this.chart.options.plugins.annotation.annotations.line1.label.content = this.getLegendFromCMS(3, 1).toUpperCase();
    // this.chart.options.plugins.annotation.annotations.line2.label.content = this.getLegendFromCMS((isHeating ? 4 : 5), 1).toUpperCase();
    // this.chart.options.plugins.annotation.annotations.box1.display = (datasetIndex < 3)
    // this.chart.options.plugins.annotation.annotations.box2.display = (datasetIndex < 3)
    this.chart.options.plugins.annotation.annotations.box2.label.content = this.getLegendFromCMS(8, 1).toUpperCase();

    if (datasetIndex < 3) {
      this.chart.options.plugins.annotation.annotations.box1.label.content = this.getLegendFromCMS(7, 1).toUpperCase();
      if (datasetIndex !== 0) this.chart.options.plugins.annotation.annotations.box1.label.content += " — " + this.getLegendFromCMS((isHeating ? 4 : 5), 1).toUpperCase()
      if (datasetIndex !== 0) this.chart.options.plugins.annotation.annotations.box2.label.content += " — " + this.getLegendFromCMS(6, 1).toUpperCase()
      this.chart.options.plugins.annotation.annotations.line3.label.content = this.getLegendFromCMS(6, 1).toUpperCase();
      this.chart.options.plugins.annotation.annotations.box1.backgroundColor = green;
      this.chart.options.plugins.annotation.annotations.box2.backgroundColor = red;
      this.setLine2X(26);
      this.setLine3X(33);
    } else {
      this.chart.options.plugins.annotation.annotations.box1.label.content = this.getLegendFromCMS((isHeating ? 4 : 5), 1).toUpperCase()
      this.chart.options.plugins.annotation.annotations.box2.label.content = this.getLegendFromCMS(10, 1).toUpperCase()
      this.chart.options.plugins.annotation.annotations.line1.label.content = this.getLegendFromCMS(9, 1).toUpperCase();
      this.chart.options.plugins.annotation.annotations.line3.label.content = this.getLegendFromCMS(10, 1).toUpperCase();
      this.chart.options.plugins.annotation.annotations.box2.label.content = this.getLegendFromCMS(10, 1).toUpperCase()
      this.chart.options.plugins.annotation.annotations.box1.backgroundColor = greenTransparent;
      this.chart.options.plugins.annotation.annotations.box2.backgroundColor = redTransparent;
      this.setLine2X(27);
      this.setLine3X(51);
    }

    // For base mode, hide annotations
    this.chart.options.plugins.annotation.annotations.box1.display = (!isBase || (datasetIndex < 3));
    this.chart.options.plugins.annotation.annotations.box2.display = (!isBase || (datasetIndex < 3));
    this.chart.options.plugins.annotation.annotations.line2.display = (!isBase || datasetIndex < 3);
    this.chart.options.plugins.annotation.annotations.line3.display = (!isBase | datasetIndex < 3);

    this.chart.options.plugins.title.text = this.getLegendFromCMS(11, 1)?.toUpperCase();

    super.loadDataset(datasetIndex);
  }

  setLine2X(value) {
    this.chart.options.plugins.annotation.annotations.line2.xMin = value
    this.chart.options.plugins.annotation.annotations.line2.xMax = value;
    this.chart.options.plugins.annotation.annotations.box1.xMax = value
    this.chart.options.plugins.annotation.annotations.box2.xMin = value;
  }

  setLine3X(value) {
    this.chart.options.plugins.annotation.annotations.line3.xMin = value
    this.chart.options.plugins.annotation.annotations.line3.xMax = value;
    this.chart.options.plugins.annotation.annotations.box2.xMax = value;
  }

  async buildDataset(filename) {
    return await super.buildDatasetFromCSV(filename, 2);
  }
}
